import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PRELAUNCH_COMBINED_LEGAL_ACKNOWLEDGEMENT } from "@bw/shared";

interface ConsentStepProps {
  accepted: boolean;
  onAcceptedChange: (next: boolean) => void;
}

/** Nonbinding QA acknowledgement; this does not record legal acceptance. */
export function ConsentStep({ accepted, onAcceptedChange }: ConsentStepProps) {
  return (
    <Stack
      component="section"
      aria-label="Prelaunch legal drafts"
      spacing={1.25}
      sx={{ pt: 0.5 }}
    >
      <Typography color="text.secondary" variant="body2">
        Review the nonbinding Badminton Warriors{" "}
        <Link component={RouterLink} to="/terms">
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link component={RouterLink} to="/privacy">
          Privacy Policy
        </Link>
        .
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={accepted}
            onChange={(event) => onAcceptedChange(event.target.checked)}
            slotProps={{ input: { "aria-required": true } }}
          />
        }
        label={
          <Box component="span">
            {PRELAUNCH_COMBINED_LEGAL_ACKNOWLEDGEMENT}.
          </Box>
        }
        sx={{ alignItems: "flex-start", m: 0 }}
      />
    </Stack>
  );
}
